<template>
  <modal
      size="modal-lg"
      :show-divider="false"
      :show="show"
      @close="$emit('close')"
  >
    <template v-slot:header>
      <sr-header
          :video="video"
          class="md:-mb-3"
      />
    </template>

    <template v-slot:body>
      <div class="-mx-4 -mt-4 lg:mx-0 lg:-mt-6">
        <video-player
          class="w-full"
          :video="_video"
        />
      </div>

      <ContextualMessage
          color="blue"
          class="my-2"
          :dismissable="false"
          v-if="showPanoramicMessage"
      >
        <p>Did the play go off screen? You can record a new clip from the panoramic capture in our <a href="/video/reel-editor" class="cursor-select underline">Highlight Reel Editor</a></p>
      </ContextualMessage>

      <div class="flex flex-col justify-between md:flex-row">
        <div class="w-full md:w-1/2 md:pr-10">
          <description :video="video"/>
        </div>

        <div
            class="w-full md:w-1/2 xm:w-1/3 md:pl-3 xm:pl-5"
            style="flex-shrink: 0"
        >
          <stats :video="video"/>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import SrHeader from "./Header";
import Stats from "./Stats";
import VideoPlayer from "@/components/VideoPlayer";
import {Modal, ContextualMessage} from '@sportsrecruits/playbook';
import Description from "./Description";
import {createVideoView} from "@/services/viewTracker";
import {mapState} from 'vuex';

export default {
  components: {
    Description,
    SrHeader,
    Stats,
    VideoPlayer,
    Modal,
    ContextualMessage,
  },
  props: {
    show: {type: Boolean, default: true},
    video: {type: Object, required: true},
    showPanoramicMessage: {type: Boolean},
  },
  computed: {
    ...mapState('athleteProfile', ['isModal']),
    _video() {
      return {...this.video,
        video_host: this.video.host,
        video_host_id: this.video.hostId,
        reel_project_id: this.video.reelProjectId,
        duration: this.video.durationInMilliseconds,
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.trackView();
        }
      },
    },
  },
  methods: {
    trackView() {
      createVideoView({resource_id: this.video.id, source: this.isModal ? 'discover' : null});
    },
  },
};
</script>
